import React from 'react'
import AllRoutes from './Components/AllRoutes/AllRoutes'

const App = () => {
  return (
    <div>
      <AllRoutes />
    </div>
  )
}

export default App